// Tilray
export const TILRAY_STRAINS = [
  {
    id: "tilray-cataract-kush",
    name: "Cataract Kush",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "LA Confidential × OG Kush",
    thc: 18, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Drzewny", "Ziemisty", "Korzenny"],
    description: "Mircen zapewnia działanie uspokajające i odprężające, wzmagane przez linalol i bisabolol. Działanie narasta stopniowo. Pierwsze odczucia mogą być subtelne, a pełnia mocy i uczucie ciężkich powiek pojawiają się po kilkunastu minutach od inhalacji. Pacjenci zgłaszają efekt relaksujący, wyciszający i poprawę jakości snu.",
    terpenes: { mircen: 28, limonen: 17, kariofilen: 20, linalol: 9, pinen: 14, humulen: 6 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "tilray-cataract-kush-22",
    name: "Cataract Kush",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "LA Confidential × OG Kush",
    thc: 22, cbd: 0.5,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Drzewny", "Ziemisty", "Korzenny"],
    description: "Mircen zapewnia działanie uspokajające i odprężające, wzmagane przez linalol i bisabolol. Działanie narasta stopniowo. Pierwsze odczucia mogą być subtelne, a pełnia mocy i uczucie ciężkich powiek pojawiają się po kilkunastu minutach od inhalacji. Pacjenci zgłaszają efekt relaksujący, wyciszający i poprawę jakości snu.",
    terpenes: { mircen: 28, limonen: 17, kariofilen: 20, linalol: 9, pinen: 14, humulen: 6 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "tilray-blueberry",
    name: "Blueberry",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "DJ Short Blueberry",
    thc: 18, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Borówkowy", "Słodki", "Owocowy"],
    description: "Dominujący mircen zapewnia działanie relaksujące, odprężające i poprawiające jakość snu, co wzmaga linalol. Dzięki kariofilenowi susz działa dodatkowo przeciwbólowo i przeciwzapalnie. Pacjenci zgłaszają przyjemny, kwiatowo-jagodowy smak i odprężające działanie na ciało bez nadmiernego otępienia, polecając odmianę do lżejszego relaksu.",
    terpenes: { mircen: 25, linalol: 5, bisabolol: 3, humulen: 13 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "tilray-blueberry-22",
    name: "Blueberry",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "DJ Short Blueberry",
    thc: 22, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Jagodowy", "Owocowy", "Ziemisty"],
    description: "Dominujący w profilu terpenowym mircen powoduje silne zrelaksowanie i wyciszenie, a w wyższych dawkach sedację, nasilaną przez linalol i bisabolol. To połączenie terpenów wykazuje też działanie anksjolityczne (przeciwlękowe) i analgetyczne (przeciwbólowe) - to ostatnie nasila dodatkowo zawartość humulenu. Lek zdecydowanie do stosowania w godzinach wieczornych.",
    terpenes: { mircen: 25, linalol: 5, bisabolol: 3, humulen: 13 },
    dominantTerpene: "Mircen", packaging: "15g",
    dateAdded: "2026-08-18"
  },
  {
    id: "tilray-purps",
    name: "Purps",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodówód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Kwaśny", "Owocowy", "Ziemisty"],
    description: "Hybrydowa odmiana od Tilray z przewagą genów indica (ok. 70%), wyróżniająca się głębokim, uspokajającym działaniem i intensywnym aromatem. Idealna na póżne popołudnie i wieczór. Dzięki wysokiej zawartości limonenu i linalolu oferuje odprężenie i poprawę nastroju. Pacjenci zgłaszają w niższych dawkach efekt przeciwbólowy, w wyższych głębszą relaksację i poprawę jakości snu.",
    terpenes: { kariofilen: 25, nerolidol: 24, bisabolol: 11, limonen: 11, linalol: 8, mircen: 6, pinen: 5, humulen: 9, ocymen: 1 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "tilray-beach-crasher-22",
    name: "Beach Crasher",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "White Widow × Wedding Crasher",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Pieprzowy", "Sosnowy", "Ziemisty"],
    description: "Hybryda/indica od Tilray o wysokiej zawartości THC 22%. Kariofilen powoduje silne działanie przeciwbólowe i przeciwzapalne. Linalol powoduje uspokojenie i wyciszenie oraz poprawę jakości snu, co sprawia, że odmiana jest odpowiednia do stosowania w godzinach wieczornych.",
    terpenes: { kariofilen: 43, humulen: 11, limonen: 13, linalol: 9, pinen: 5, bisabolol: 5 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "tilray-pink-kush",
    name: "Pink Kush",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "OG Kush × Hindu Kush",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kamfora", "Pieprzowy", "Pikantny"],
    description: "Indica od Tilray, powstała z połączenia renomowanych odmian OG Kush i Hindu Kush. Znana jako skuteczny środek przeciwbólowy, przeciwzapalny i przeciwlękowy, dzięki zawartości kariofilenu i nerolidolu. Skuteczna w łagodzeniu stresu i lęku, szczególnie w wieczornych stosowaniach.",
    terpenes: { nerolidol: 6, kariofilen: 5, bisabolol: 2, humulen: 1 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "tilray-master-kush-22",
    name: "Master Kush",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "Hindu Kush × Skunk",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kamfora", "Korzenny", "Pieprzowy", "Ziemisty"],
    description: "Dzięki dominującym kariofilenowi i nerolidolowi susz o genetyce indica wykazuje silne działanie przeciwbólowe, przeciwzapalne relaksujące i odprężające. Efekt ten nasila obecny w odmianie mircen. Pacjenci zwracają uwagę na złożone, wielofazowe działanie — od redukcji bólu i euforii, przez spokój i ciszę, aż po głęboki sen; szczególnie doceniany przy dolegliwościach bólowych.",
    terpenes: { kariofilen: 26, nerolidol: 24, bisabolol: 10, limonen: 10, humulen: 4, mircen: 4, linalol: 4, pinen: 2 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "tilray-lilac-diesel-22",
    name: "Lilac Diesel",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Diesel", "Kwiatowy", "Lawendowy"],
    description: "Hybryda/sativa pobudza do działania i dodaje energii, dzięki dużej zawartości limonenu. Pozostałe terpeny odpowiadają za redukcję zmęczenia i wrażenia odprężenia całego organizmu.",
    terpenes: { terpinolen: 23, mircen: 8, kariofilen: 8, pinen: 7, limonen: 6, bisabolol: 3, humulen: 3 },
    dominantTerpene: "Terpinolen", packaging: "15g"
  },
  {
    id: "tilray-lilac-diesel-18",
    name: "Lilac Diesel",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "nieznany rodowód",
    thc: 18, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Diesel", "Kwiatowy", "Lawendowy"],
    description: "Hybryda/sativa pobudza do działania i dodaje energii, dzięki dużej zawartości limonenu. Pozostałe terpeny odpowiadają za redukcję zmęczenia i wrażenia odprężenia całego organizmu. Pacjenci cenią sobie tę odmianę za działanie aktywizujące, zgłaszają m.in. gonitwę myśli i gadatliwość.",
    terpenes: { terpinolen: 23, mircen: 8, kariofilen: 8, pinen: 7, limonen: 6, bisabolol: 3, humulen: 3 },
    dominantTerpene: "Terpinolen", packaging: "15g"
  },
  {
    id: "tilray-island-sweet-skunk-22",
    name: "Island Sweet Skunk",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Sativa",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Mango", "Miętowy", "Sosnowy"],
    description: "Sativa o wyjątkowo bogatym profilu terpenowym. Synergia m.in. limonenu i terpinolenu odpowiada za działanie aktywizujące i zmniejszające stan zapalny, co potęguje dominujący w suszu pinen.",
    terpenes: { pinen: 19, kariofilen: 15, humulen: 9, ocymen: 2, limonen: 4, terpinolen: 14, bisabolol: 9, mircen: 7, nerolidol: 10 },
    dominantTerpene: "Pinen", packaging: "15g"
  },
  {
    id: "tilray-frosted-cherry-cookies-22",
    name: "Frosted Cherry Cookies",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Jagodowy", "Sosnowy", "Ziołowy"],
    description: "Frosted Cherry Cookies to hybryda z dominacją genetyki indica (70/30) o THC 22%, wyróżniająca się intensywnym aromatem jagód, cytrusów, sosny i ziół. Dominujący mircen odpowiada za głęboki relaks mięśniowy i działanie sedatywne, wspierając sen i redukując napięcie. Kariofilen — wiążąc się bezpośrednio z receptorami CB2 — zapewnia silne działanie przeciwzapalne i przeciwbólowe, szczególnie w bólu neuropatycznym, a pinen wykazuje właściwości przeciwzapalne.",
    terpenes: { mircen: 27, pinen: 27, kariofilen: 11, limonen: 8, humulen: 6 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "tilray-headband-18",
    name: "Headband",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda",
    lineage: "OG Kush × Sour Diesel",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Diesel", "Drzewny"],
    description: "Headband to hybryda powstała z krzyżowania OG Kush i Sour Diesel, oferująca długotrwałe łagodzenie bólu, relaksację ciała oraz skuteczną redukcję stresu. Dominujący nerolidol zapewnia silne działanie uspokajające i przeciwbólowe, które potęguje kariofilen. Bisabolol wzmacnia efekt relaksujący, a limonen wspiera poprawę nastroju i działa przeciwdepresyjnie. Nazwa pochodzi od uczucia opaski na głowie zaraz po inhalacji.\nPacjenci cenią odmianę za działanie przeciwdepresyjne, poprawiające nastrój bez zbędnej euforii.",
    terpenes: { nerolidol: 25, kariofilen: 21, bisabolol: 16, limonen: 9, humulen: 9 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "tilray-blue-cheese-18",
    name: "Blue Cheese",
    producer: "Tilray",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    thc: 18, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Słodki", "Serowy", "Kwiatowy", "Owocowy"],
    description: "Hybryda z dominantą indica od Tilray wykazuje silne działanie przeciwzapalne, dzięki m.in. dominującemu kariofilenowi, który jako jedyny łączy się z receptorem CB2, oraz humulenowi, który bezpośrednio wpływa na uwalnianie histaminy. Susz działa uspokajająco i anksjolitycznie, co możemy wiązać z obecnością w profilu terpenowym linalolu i nerolidolu - ten pierwszy działa łagodząco na objawy migreny i obniża poziom mediatorów uczestniczących w jej mechanizmach.",
    terpenes: { kariofilen: 27, limonen: 17, humulen: 10, nerolidol: 9, linalol: 9, mircen: 9, pinen: 6 },
    dominantTerpene: "Kariofilen", packaging: "15g",
    dateAdded: "2026-11-04T08:00:00", isNew: true
  }
];